/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type {CustomerProvisioningStatusResponse} from '../models/CustomerProvisioningStatusResponse';
import type {Entitlement} from '../models/Entitlement';
import type {PermissionCheckResponse} from '../models/PermissionCheckResponse';
import type {CancelablePromise} from '../core/CancelablePromise';
import type {BaseHttpRequest} from '../core/BaseHttpRequest';
export class EntitlementsService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Gets all entitlements for the current user.
   * This endpoint is called on app-load to populate the React Context.
   * @returns Entitlement OK
   * @throws ApiError
   */
  public entitlementsGetMyEntitlements(): CancelablePromise<
    Record<string, Entitlement>
  > {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/Entitlements/me',
      errors: {
        401: `Unauthorized`,
      },
    });
  }
  /**
   * Gets the entitlement for a specific feature.
   * @returns Entitlement OK
   * @throws ApiError
   */
  public entitlementsGetFeatureEntitlement({
    featureKey,
  }: {
    /**
     * The feature key to check.
     */
    featureKey: string;
  }): CancelablePromise<Entitlement> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/Entitlements/{featureKey}',
      path: {
        featureKey: featureKey,
      },
      errors: {
        401: `Unauthorized`,
      },
    });
  }
  /**
   * Evaluates a permission directly for the current user, independent of any feature: does one of the
   * caller's JWT role(s) grant the given permission. Intended for service-to-service gating of
   * non-feature actions (e.g. ManageBilling, ExportData). There is no permissive default - an
   * unassigned or unknown permission is denied.
   * @returns PermissionCheckResponse OK
   * @throws ApiError
   */
  public entitlementsGetPermissionCheck({
    permissionKey,
  }: {
    /**
     * The permission key to check (e.g., "ManageBilling").
     */
    permissionKey: string;
  }): CancelablePromise<PermissionCheckResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/Entitlements/permissions/{permissionKey}',
      path: {
        permissionKey: permissionKey,
      },
      errors: {
        401: `Unauthorized`,
      },
    });
  }
  /**
   * Reports whether the current user's organization is provisioned as a ReswareAI customer.
   * The UI calls this on app-load to present a clear message when an organization isn't set up.
   * A user authenticated without an org_id claim (no WorkOS organization) is reported as not
   * provisioned (the same "not set up" state) rather than as an error.
   * @returns CustomerProvisioningStatusResponse OK
   * @throws ApiError
   */
  public entitlementsGetCustomerStatus(): CancelablePromise<CustomerProvisioningStatusResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/Entitlements/me/customer-status',
      errors: {
        401: `Unauthorized`,
      },
    });
  }
}
